export const ORIGIN_OUTBOUND = "outbound-phone";
export const ORIGIN_INBOUND = "inbound-phone";
export const CHAT_TO_PHONE = "chat-to-phone";
export const BOT_TO_PHONE = "bot-to-phone";